import styled from "styled-components"
import { COLOR } from "utils/color"
import { LoadingComponent } from "../../LoadingComponent"

export const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const ButtonStyled = styled.button<{ isDownload?: string }>`
  color: ${COLOR.WHITE};
  font-weight: 600;
  font-size: 13px;
  background-color: ${({ isDownload }: { isDownload?: string }) => (isDownload ? COLOR.LIGHT_GREY : COLOR.BRIGHT_BLUE)};
  border-radius: 5px;
  max-width: 393px;
  width: 100%;
  padding: 8px 30px;
  margin-top: 16px;
  border: 0;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${COLOR.BLUE};
    background-color: ${({ isDownload }: { isDownload?: string }) => (isDownload ? COLOR.GREY : COLOR.BLUE)};
  }
`

export const ItalicText = styled.span`
  font-style: italic;
`

export const LoadingComponentStyled = styled(LoadingComponent)`
  margin-top: 30px;
`

export const XMLGenResults = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`
export const XMLGenResultItem = styled.div`
  font-size: 12px;
`

export const XMLGenResultItemTitle = styled.span`
  font-weight: 600;
`
